// src/utils/services/AdvancedMD/annualWellness20.js
import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const ANNUAL_WELLNESS20_URL = `${API_BASE_URL}/api/advancedmd/patients`;

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
});

/**
 * Obtiene las notas "Annual Wellness 2.0" de un paciente.
 */
export async function getAnnualWellness20Notes(patientId) {
  try {
    const url = `${ANNUAL_WELLNESS20_URL}/${encodeURIComponent(patientId)}/annual-wellness-20`;
    const res = await axios.get(url, { headers: authHeader() });
    return res.data;
  } catch (err) {
    console.error("Error getAnnualWellness20Notes:", err);
    throw err;
  }
}